import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=4a56509f&scoped=true&lang=pug&"
import script from "./CustomSearch.vue?vue&type=script&lang=js&"
export * from "./CustomSearch.vue?vue&type=script&lang=js&"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=4a56509f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56509f",
  null
  
)

export default component.exports